// extracted by mini-css-extract-plugin
export var authorImage = "GoogleReviews-module--authorImage--23b05";
export var authorInfo = "GoogleReviews-module--authorInfo--000bf";
export var authorName = "GoogleReviews-module--authorName--f8a7c";
export var container = "GoogleReviews-module--container--e6d3b";
export var reviewCard = "GoogleReviews-module--reviewCard--2832f";
export var reviewContent = "GoogleReviews-module--reviewContent--948c3";
export var reviewText = "GoogleReviews-module--reviewText--a7d3f";
export var sectionStyling = "GoogleReviews-module--sectionStyling--d8fb6";
export var star = "GoogleReviews-module--star--687e3";
export var starsContainer = "GoogleReviews-module--starsContainer--86afa";